import { render } from "./box-clamp.vue?vue&type=template&id=8f7e9a8a&scoped=true"
import script from "./box-clamp.vue?vue&type=script&lang=ts"
export * from "./box-clamp.vue?vue&type=script&lang=ts"

import "./box-clamp.vue?vue&type=style&index=0&id=8f7e9a8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f7e9a8a"

export default script